// Slice 40 — screen registry. Each later slice (41–47) replaces its entry
// with the real implementation; the Placeholder content is honest about
// what's coming so the shell is never empty / never misleading.
//
// Slice 53 — deep-link aware: when the hash carries a sub-path
// (#/customers/cus_abc), the screen-router renders the drill-down screen
// instead of the list. Lives here so a) the Shell doesn't need to know
// per-screen routing rules, and b) other screens can pick up the same
// pattern in later slices (licenses/:id, feedback/:id) without growing
// the RouteId enum.

import { useRouter } from "../router/router";
import { AuditScreen } from "./audit/AuditScreen";
import { CustomerDetailScreen } from "./customers/CustomerDetailScreen";
import { CustomersScreen } from "./customers/CustomersScreen";
import { FeedbackScreen } from "./feedback/FeedbackScreen";
import { LicenseDetailScreen } from "./licenses/LicenseDetailScreen";
import { LicensesScreen } from "./licenses/LicensesScreen";
import { OverviewScreen } from "./overview/OverviewScreen";
import { PrivacyScreen } from "./privacy/PrivacyScreen";
import { SettingsScreen } from "./settings/SettingsScreen";
import { StaffScreen } from "./staff/StaffScreen";
import { TelemetryScreen } from "./telemetry/TelemetryScreen";

export function renderScreen(_route: ReturnType<typeof useRouter>["route"]) {
  // The Shell calls us with the parsed route, but to read segments we go
  // back through the hook — keeping the existing renderScreen-by-route
  // signature so Shell.tsx stays untouched.
  return <ScreenRouter />;
}

function ScreenRouter() {
  const { route, segments } = useRouter();
  switch (route) {
    case "overview":
      return <OverviewScreen />;
    case "licenses":
      if (segments[0]) return <LicenseDetailScreen licenseId={segments[0]} />;
      return <LicensesScreen />;
    case "feedback":
      return <FeedbackScreen />;
    case "customers":
      if (segments[0]) return <CustomerDetailScreen customerId={segments[0]} />;
      return <CustomersScreen />;
    case "telemetry":
      return <TelemetryScreen />;
    case "privacy":
      return <PrivacyScreen />;
    case "audit":
      return <AuditScreen />;
    case "staff":
      return <StaffScreen />;
    case "settings":
      return <SettingsScreen />;
  }
}
